<template>
  <section class="m-5">
    <div class="row">
      <div class="col mt-3 text-center">
        <h4>Recherche rapide d'attributs</h4>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-lg-4">
        <gwzAutoComplete
          id="input-autoComplete"
          :http="httpMirakl"
          v-model="attributeLabel"
          labelName="label"
          queryParamName="label"
          nameEndpoint="listMiraklAttributes"
          placeholder="Rechercher un attribut"
          @response="goToAttribute"
        ></gwzAutoComplete>
      </div>
    </div>
  </section>
</template>

<script>
import gwzAutoComplete from "@/components/gwzAutoComplete";

export default {
  name: "AttributesQuickSearch.vue",
  components: { gwzAutoComplete },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("attributes"),
      attributeLabel: ""
    };
  },
  methods: {
    goToAttribute(item) {
      this.$router.push({ name: "EditAttribute", params: { id: item.id } });
    }
  }
};
</script>

<style scoped></style>
